import {
  GATELOYALTYPOINTOPERATIONSLIST_SUCCESS,
  GATELOYALTYPOINTOPERATIONSLIST_FAILED,
  RESET_GATELOYALTYPOINTOPERATIONSLIST,
  LOADING_GATELOYALTYPOINTOPERATIONSLIST,
  NETWORK_ERROR_GATELOYALTYPOINTOPERATIONSLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGateLoyaltyPointOperationsList = () => {
  return { type: RESET_GATELOYALTYPOINTOPERATIONSLIST };
};

const gateLoyaltyPointOperationsListReq =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GATELOYALTYPOINTOPERATIONSLIST });
    await partnerServices
      .post("gateLoyaltyPointOperationsList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(gateLoyaltyPointOperationsListSuccess(res.data));
            break;
          default:
            dispatch(gateLoyaltyPointOperationsListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GATELOYALTYPOINTOPERATIONSLIST,
          payload: err,
        });
      });
  };
function gateLoyaltyPointOperationsListSuccess(data) {
  return {
    type: GATELOYALTYPOINTOPERATIONSLIST_SUCCESS,
    payload: data,
  };
}
function gateLoyaltyPointOperationsListFailed(data) {
  return {
    type: GATELOYALTYPOINTOPERATIONSLIST_FAILED,
    payload: data,
  };
}

export {
  resetGateLoyaltyPointOperationsList,
  gateLoyaltyPointOperationsListReq,
};
